export const Url="https://mirx.com.ar/pv/";
//export const Url="https://mirx.com.ar/elrebajon/";
//export const Url="https://mirx.com.ar/jn/";
//export const Url="https://mirx.com.ar/personaliza2/";
//export const Url="https://mirx.com.ar/pventa/";
